import { userService } from "../_services";
import { router } from "../_helpers";

const initialState = () => ({
  status: {
    loggingIn: false
  },
  productsData: null
});

const state = initialState();

const actions = {
  clearLoginData({ commit }) {
    commit("logout");
    commit("reset");
    commit("order/reset", {}, { root: true });
  },
  login({ dispatch, commit }, formData) {
    commit("loginRequest");

    userService
      .login(formData)
      .then(user => {
        dispatch("product");
        dispatch("shipping/getCarriers", null, { root: true });
        setTimeout(() => {
          router.push("/dashboard");
        });
        setTimeout(() => {
          commit("loginSuccess", user);
        });
      })
      .catch(err => {
        commit("loginFailure", err);
        let errors = err;
        if (Array.isArray(err)) {
          errors = err.reduce((text, singleErr) => {
            return text + ` ${singleErr}`;
          }, "");
        }
        dispatch(
          "alert/alert",
          { title: "Wystąpił błąd!", message: errors },
          { root: true }
        );
      });
  },
  logout({ commit, dispatch }) {
    userService.logout().finally(() => {
      commit("logout");
      commit("reset");
      commit("order/reset", {}, { root: true });
      router.push("/login");
      setTimeout(() => {
        dispatch(
          "alert/alert",
          { title: "Wszystko OK!", message: "Wylogowano pomyślnie!" },
          { root: true }
        );
      });
    });
  },
  product({ commit }) {
    userService.product().then(({ products }) => {
      commit("updateProducts", products);
    });
  }
};

const mutations = {
  reset(state) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  loginRequest(state) {
    state.status = { loggingIn: true };
  },
  loginSuccess(state, user) {
    state.status = { loggingIn: false };
    localStorage.setItem("userData", JSON.stringify(user));
    localStorage.setItem("loggedIn", JSON.stringify(true));
  },
  loginFailure(state, error) {
    state.status = { loggingIn: false, error };
    localStorage.clear();
  },
  logout() {
    localStorage.clear();
  },
  updateProducts(state, products) {
    state.productsData = products;
  }
};

const getters = {
  user() {
    return JSON.parse(localStorage.getItem("userData"));
  },
  loggedIn() {
    return JSON.parse(localStorage.getItem("loggedIn"));
  },
  products(state) {
    return state.productsData;
  }
};

export const user = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
